import { Alert, Table } from 'antd'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import { moneyColumn, numVal, strVal } from '../../../modules/Utils'
import React from 'react'
import { Link } from 'react-router-dom'

ManagementList.propTypes = {}

function ManagementList(props) {
  const { list, fetching } = props
  console.log({ list })
  const columns = [
    {
      title: <strong>Name</strong>,
      dataIndex: 'name',
      width: 325,
      fixed: 'left',
      style: {
        textAlign: 'left',
        // marginLeft: '0.5rem',
      },
      render: (value, original) => {
        if (strVal(original, '_id').includes('vouchers/'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/purchasing/vouchers/${original._id.replace('vouchers/', '')}/update`,
              }}>
              <span style={{ marginLeft: '1rem' }}>{value}</span>
            </Link>
          )
        if (strVal(original, '_id').includes('invoices/'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/clients/invoices/${original._id.replace('invoices/', '')}/view`,
              }}>
              <span style={{ marginLeft: '1rem' }}>{value}</span>
            </Link>
          )
        return original.style ? (
          <strong
            style={{
              marginLeft: original.isHeader && '-1.5rem',
              fontSize: original.isHeader ? '1rem' : '1rem',
              textTransform: 'uppercase',
              textAlign: 'left',
            }}>
            {value}
          </strong>
        ) : (
          <span style={{ marginLeft: '1rem' }}>{value}</span>
        )
      },
    },
    ...list.periods.map(r => ({
      title: <strong>{r.name}</strong>,
      dataIndex: r.name,
      width: 135,
      render: (value, original) =>
        value && (
          <span
            style={{
              fontSize: '0.9rem',
              textTransform: 'uppercase',
              textAlign: 'left',
              fontWeight: original.style && 'bold',
            }}>
            {value < 0
              ? `(${moneyColumn(numVal({ value: value * -1 }, 'value'))})`
              : moneyColumn(numVal({ value }, 'value'))}
          </span>
        ),
      headerStyle: {
        textAlign: 'right',
      },
      style: {
        textAlign: 'right',
      },
    })),
  ]

  return (
    <div style={{ overflowY: 'scroll' }}>
      <FormSectionTitle title={'Consolidated Trading Report (USD)'} />
      <Alert
        style={{ marginBottom: 20 }}
        message="The Report Is Very Wide, Note That You Can Scroll Horizontally"
        type="info"
        showIcon
      />

      <Table
        key={new Date().getTime().toString()}
        pagination={{ pageSize: 50 }}
        loading={fetching}
        columns={columns}
        dataSource={list.data}
        rowKey={'name'}
        scroll={{ x: 2000 }}
      />
    </div>
  )
}

export default ManagementList
